import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withLoader from 'components/Shared/withLoader';
import InfoSuiviColis from './InfoSuiviColis';
import { fetchPieceInfosSuiviColis } from 'store/suiviColis/suiviColisActions';

const InfoSuiviColisWithLoader = withLoader(InfoSuiviColis);

class InfoSuiviColisContainer extends React.Component {

    getCleApi() {
        const { piece, numeroPiece } = this.props;
        return piece?.bonLivraisonGestionCle || piece?.demandeTransfertGestionCle || numeroPiece;
    }

    componentDidMount() {
        const { fetchPieceInfosSuiviColis } = this.props;

        fetchPieceInfosSuiviColis(this.getCleApi());
    }

    componentDidUpdate(prevProps) {
        const { fetchPieceInfosSuiviColis } = this.props;
        const prevCle = prevProps.piece?.bonLivraisonGestionCle || prevProps.piece?.demandeTransfertGestionCle || prevProps.numeroPiece;

        if (prevCle !== this.getCleApi()) {
            fetchPieceInfosSuiviColis(this.getCleApi());
        }
    }


    render() {
        const { isLoading, suivisColis, afficheSuiviColisDetaille } = this.props;
        const cleApi = this.getCleApi();

        const suiviColis = suivisColis.find(x => x.numeroPiece === cleApi);


        return (
            <InfoSuiviColisWithLoader
                isLoading={isLoading}
                urlPreuveLivraison={suiviColis !== undefined ? suiviColis.urlPreuveLivraison : null}
                urlSuiviColis={suiviColis !== undefined ? suiviColis.urlSuivi : null}

                urlSuiviColisDetaille={suiviColis !== undefined ? suiviColis.urlSuiviColisDetaille : null}
                afficheSuiviColisDetaille={afficheSuiviColisDetaille !== undefined ? afficheSuiviColisDetaille : false}
            />
        );
    }
}

InfoSuiviColisContainer.propTypes = {
    piece: PropTypes.object,
    numeroPiece: PropTypes.string,
    afficheSuiviColisDetaille: PropTypes.bool
};

const mapStateToProps = state => ({
    isLoading: state.suiviColis.isInfosSuiviColisLoading,
    suivisColis: state.suiviColis.suivisColis
});

const mapDispatchToProps = dispatch => ({
    fetchPieceInfosSuiviColis: (numeroPiece) => dispatch(fetchPieceInfosSuiviColis(numeroPiece))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoSuiviColisContainer);